import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { getConnectedDeviceName } from '../../../../hooks/useBrandConfig'

import {
    sendBytes,
    ZingByteCodes,
    AceByteCodes,
} from '../../../ReusableComponents/ByteTransfer'
import speechToCommand from '../speechToCommand'
import {
    describeSpeechConflict,
    findSpeechConflict,
    normalizeSpeech,
} from '../speechConflicts'
import renderImage from '../../../../source/importImg'
import { getConnectedDeviceImage } from '../../../../hooks/useBrandConfig'
import SpchSlider from '../../../ReusableComponents/SpchSlider/SpchSlider'
import MainHeader from '../../../ReusableComponents/Header/MainHeader'
import './speak.scss'
import { HexapodByteCodes } from '../../../ReusableComponents/ByteTransfer/byteCodes'
import unicodeToChar from '../../../../utils/unicodeToChar'
import { languageWords } from '../../../../utils/langaugeSupport'
import Toast from '../../../ReusableComponents/UI/Toast.jsx'
import DialogModal from '../../../ReusableComponents/DialogModal/DialogModal'
import CustomWards, { ActionsList } from './CustomWards'
import { speechLanguageMenu } from '../../../../redux/reducers/plaModeStorage'
import { zingFreeFallSendBytes } from '../../../../utils/freeFallBytes'
import {
    ZingPlayFrames,
    isZingPlayFrameVersion,
} from '../../../ReusableComponents/ByteTransfer/zingPlayFrame'
import { getZingSpeechBytes } from '../zingSpeechBytes'

export const speechLanguageCodes = {
    English: 'en-US',
    Hindi: 'hi-IN',
    Kannada: 'kn-IN',
    Telugu: 'te-IN',
    Odia: 'or-IN',
    Marathi: 'mr-IN',
    Malayalam: 'ml-IN',
}
const feedbackStyle = {
    height: 'auto',
    fontSize: '19px',
    fontFamily: 'Halcyon_Medium !important',
    color: '#707070',
    bottom: '6%',
}

// Framed Zing walks/turns until attention is sent, so a speech walk or turn is timed to a set number of steps
const ZING_WALK_STEPS = 2
const ZING_TURN_STEPS = 2
const ZING_STEP_MS = 1200
const ZING_TIMED_STEPS = {
    MOVEFORWARD: ZING_WALK_STEPS,
    MOVEBACKWARD: ZING_WALK_STEPS,
    TURNLEFT: ZING_TURN_STEPS,
    TURNRIGHT: ZING_TURN_STEPS,
}

// Readable names for the matched commands shown in the feedback text
const COMMAND_LABELS = {
    MOVEFORWARD: 'Move Forward',
    MOVEBACKWARD: 'Move Backward',
    FORWARD: 'Move Forward',
    FRONT: 'Move Forward',
    BACK: 'Move Backward',
    MOVELEFT: 'Move Left',
    MOVERIGHT: 'Move Right',
    TURNLEFT: 'Turn Left',
    TURNRIGHT: 'Turn Right',
    TURNAROUND: 'Turn Around',
    SLIDELEFT: 'Slide Left',
    SLIDERIGHT: 'Slide Right',
    SIDEKICKLEFT: 'Side Kick Left',
    SIDEKICKRIGHT: 'Side Kick Right',
    FRONTKICKLEFT: 'Front Kick Left',
    FRONTKICKRIGHT: 'Front Kick Right',
    PUSHUP: 'Push Up',
    LIGHTOFF: 'Light Off',
    WHITELIGHT: 'White Light',
    REDLIGHT: 'Red Light',
    GREENLIGHT: 'Green Light',
    BLUELIGHT: 'Blue Light',
}

// let recognition = undefined

const bytesCode = {
    ACE: AceByteCodes,
    HUMANOID: ZingByteCodes,
    HEXAPOD: HexapodByteCodes,
}
const DeviceSpeech = ({
    webSerial,
    worker,
    device,
    setActionsMap,
    playModeStorage,
    setLanguageSelect,
}) => {
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    const deviceMajorVersion = parseInt(
        deviceVersion?.split('.')?.[0] ?? '0'
    )
    // AI speech mode: Zing firmware 2.x and 3.x
    const isZing3 = connectedDevice === 'Humanoid' && deviceMajorVersion >= 2
    // AI/Custom toggle: only V3 lets the user switch; V2 stays Custom-only
    const isZing3Only =
        connectedDevice === 'Humanoid' && deviceMajorVersion >= 3
    const connectedDeviceName = getConnectedDeviceName()
    const isZingFramed = isZingPlayFrameVersion(connectedDevice, deviceVersion)
    const attentionBytes = isZingFramed
        ? ZingPlayFrames.ATTENTION
        : ['R'.charCodeAt(0), 'a'.charCodeAt(0)]

    const recognitionRef = React.useRef(null)
    const speechStopRef = React.useRef(false)
    // Zing 2/3 listens only after the user taps the mic; this keeps listening
    // across a language change once they have started it.
    const wantsListeningRef = React.useRef(false)
    // whether to resume listening when an edit/language popup closes
    const resumeListeningRef = React.useRef(false)
    const isOpenEditPopUpRf = React.useRef(false)
    const isActionRunningRef = React.useRef(false)
    const isStopRequestedRef = React.useRef(false)
    const isPushUpRunningRef = React.useRef(false)
    const [showPushUpToast, setShowPushUpToast] = useState(false)

    const [isListening, setIsListening] = useState(false)
    const [swipeActive, setSwipeActive] = useState(
        isZing3Only ? 'AI' : 'Custom'
    )
    const [isShowWardEditPopUp, setIsShowWardEditPopUp] = useState(false)
    const [isShowLanguagePopUp, setIsShowLanguagePopUp] = useState(false)
    const [wardsArray, setWardsArray] = useState([])
    const [tempLanguage, setTempLanguage] = useState('')
    const [speechCommends, setSpeechCommends] = useState('')
    const [isMicActive, setIsMicActive] = useState(-1)
    const [duplicateWarning, setDuplicateWarning] = useState({
        isShow: false,
        message: '',
        onYes: () => {},
        onNo: () => {},
    })
    const [warningPopup, setWarningPopup] = useState({
        isShow: false,
        message: '',
    })
    const [feedback, setFeedback] = useState(
        `Tap the microphone to start talking to your ${connectedDeviceName}`
    )
    const languageName = device.language
    // const zingVersion = sessionStorage.getItem('zingVersion') || '0.0.0'

    const timeoutPromise = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    const checkDone = async () => {
        return new Promise(async (resolve, reject) => {
            while (true) {
                if (isStopRequestedRef.current) {
                    return resolve(true) // Instantly resolve if STOP was requested
                }
                if (!JSON.parse(sessionStorage.getItem('sendDataAsPacket'))) {
                    return resolve(true)
                }

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }
        })
    }

    // Initializing speech recognition
    useEffect(() => {
        try {
            var SpeechRecognition =
                window.SpeechRecognition || window.webkitSpeechRecognition

            recognitionRef.current = new SpeechRecognition()
            recognitionRef.current.continuous = true

            if (isZing3) {
                recognitionRef.current.lang =
                    speechLanguageCodes[playModeStorage.speech.language] ??
                    'en-US'

                setTimeout(() => {
                    if (!wantsListeningRef.current) return
                    try {
                        recognitionRef.current.start()
                    } catch (e) {
                        setFeedback(
                            'Please connect a microphone and allow microphone access'
                        )
                    }
                }, 2000)
            }
        } catch (e) {
            console.log('UUUUUUUUUUU', e)
        }
    }, [playModeStorage.speech.language])

    // useEffect(() => {
    //     try {
    //         if (isZing3) {
    //             console.log(
    //                 'HHHHHHHHH123123 isZing3 isZing3',
    //                 speechLanguageCodes[playModeStorage.speech.language]
    //             )
    //             recognitionRef.current.lang =
    //                 speechLanguageCodes[playModeStorage.speech.language] ??
    //                 'en-US'
    //         }
    //     } catch (e) {
    //         console.log('ERROR', e)
    //     }
    // }, [playModeStorage.speech.language])

    // SpeechRecognition event Listeners
    useEffect(() => {
        // console.log('XXXXXXXXXXXXXXXXXXXXXX', playModeStorage)
        recognitionRef.current.addEventListener(
            'start',
            handleRecognitionOnStart
        )
        recognitionRef.current.addEventListener('end', handleRecognitionOnEnd)
        recognitionRef.current.addEventListener(
            'result',
            handleRecognitionOnResult
        )

        recognitionRef.current.onerror = (event) => {
            if (event.error === 'aborted') return
            if (!isZing3) {
                setFeedback(event.error + ' error')
                setIsListening(false)
            }
        }

        return () => {
            recognitionRef.current.removeEventListener(
                'start',
                handleRecognitionOnStart
            )
            recognitionRef.current.removeEventListener(
                'end',
                handleRecognitionOnEnd
            )
            recognitionRef.current.removeEventListener(
                'result',
                handleRecognitionOnResult
            )
        }
    }, [webSerial, playModeStorage, isMicActive])

    async function writePort(data) {
        worker.postMessage({
            type: 'writeArray',
            value: data,
        })
        console.log('PlayBytes Sent')
    }
    const readBytes = async () => {
        if (!webSerial.port) return
        console.log('read', await webSerial.port.readable.locked)
        while (webSerial.port.readable) {
            const reader = webSerial.port.readable.getReader()
            let combinedResult = ''
            try {
                while (true) {
                    let result
                    console.log('waiting for reply...')
                    try {
                        result = await Promise.race([
                            reader.read(),
                            timeoutPromise(12000),
                        ])
                    } catch (e) {
                        reader.releaseLock()

                        console.log('While loop broken')
                        return
                    }
                    const reply = unicodeToChar(result.value).trim()
                    combinedResult = combinedResult + reply
                    if (
                        combinedResult.includes('Rdone') ||
                        combinedResult.includes('RDONE')
                    ) {
                        return combinedResult
                    }
                }
            } catch (err) {
                console.log(err)
            } finally {
                reader.releaseLock()
            }
        }
    }

    useEffect(() => {
        const handleBytesSending = async () => {
            if (webSerial.isConnected) {
                const PLAY = [
                    'P'.charCodeAt(),
                    'L'.charCodeAt(),
                    'A'.charCodeAt(),
                    'Y'.charCodeAt(),
                ]
                // const M8 = ['M'.charCodeAt(), '8'.charCodeAt()]
                const Attention = ['R'.charCodeAt(), 'a'.charCodeAt()]
                if (
                    connectedDevice == 'Ace' &&
                    sessionStorage.getItem('deviceVersion')?.startsWith('1')
                )
                    return

                await new Promise((reslove) => setTimeout(reslove, 200))
                writePort(PLAY)

                if (connectedDevice == 'Hexapod') {
                    setTimeout(async () => {
                        writePort(Attention)
                    }, 200)
                    // setTimeout(async () => {
                    //     await readBytes()
                    // }, 200)
                }
                setTimeout(() => {
                    //     writePort(M8)
                    // }, 200)
                })
            }
        }
        handleBytesSending()
    }, [webSerial.isConnected])
    // Handler functions
    const handleRecognitionOnStart = () => {
        console.log('Speech recognition service : STARTED')
        setIsListening(true)
        if (isZing3) {
            setFeedback('Listening......')
        }
    }

    const handleRecognitionOnEnd = () => {
        if (isZing3 && !speechStopRef.current) {
            setTimeout(() => {
                try {
                    recognitionRef.current.start()
                } catch (e) {
                    console.log('EEEEEEEE', e)
                }
            }, 300)
            return
        }
        console.log('Speech recognition service : STOPPED ')
        setFeedback(
            `Tap the microphone to start talking to your ${connectedDeviceName}`
        )
        setIsListening(false)
    }

    const handleRecognitionOnResult = async (e) => {
        console.log('hiiii', e)
        let speechInput = e.results[e.resultIndex][0].transcript
        let confidenceScore = e.results[e.resultIndex][0].confidence
        console.log('Input from mic: ' + speechInput + ' | Confidence: ' + confidenceScore)

        // Ignore low confidence transcripts (likely background noise)
        if (confidenceScore < 0.75) {
            console.log('Ignored due to low confidence score (background noise filter).')
            return
        }

        //open the specch commends editing page
        if (isOpenEditPopUpRf.current && isMicActive > -1) {
            // setSpeechCommends(speechInput)
            setWardsArray((prev) =>
                prev.map((item, index) =>
                    index === isMicActive
                        ? { ...item, text: speechInput }
                        : item
                )
            )
            return
        }

        const matchedPhrases = {}
        const commands = speechToCommand(
            speechInput,
            connectedDevice,
            playModeStorage,
            matchedPhrases
        )
        console.log('corresponding command: ' + commands)

        if (commands.length !== 0) {
            // Intercept STOP or ATTENTION to forcefully break any ongoing actions
            const isStopCommand = commands.some(c => c === 'STOP' || c === 'ATTENTION')

            // Push-Up must run to completion: ignore every command (incl. STOP)
            if (isPushUpRunningRef.current) {
                setShowPushUpToast(true)
                return
            }

            if (isActionRunningRef.current && !isStopCommand) {
                return // Ignore other commands if an action is currently running
            }

            if (isStopCommand) {
                isStopRequestedRef.current = true // Break any ongoing while loops
                isActionRunningRef.current = false // Force unlock
            } else {
                isStopRequestedRef.current = false
                isActionRunningRef.current = true
            }

            commands.map(async (command) => {
                const needsFallDisable =
                    connectedDevice === 'Humanoid' &&
                    ['2', '3'].includes(deviceVersion?.[0]) &&
                    command === 'PUSHUP'

                if (connectedDevice === 'Humanoid' && command === 'PUSHUP') {
                    isPushUpRunningRef.current = true
                }

                if (needsFallDisable) {
                    zingFreeFallSendBytes({ worker, value: 0 })
                    await new Promise((r) => setTimeout(r, 100))
                }

                sessionStorage.setItem('sendDataAsPacket', 'true')
                
                // Determine if this is a Hexapod continuous command that needs repeated bytes
                const isHexapodContinuous = connectedDevice === 'Hexapod' && 
                    ['FORWARD', 'FRONT', 'BACK', 'TURNLEFT', 'TURNRIGHT', 'SLIDELEFT', 'SLIDERIGHT'].includes(command)

                if (isHexapodContinuous) {
                    // Hexapod needs continuous commands sent multiple times to keep moving
                    for (let i = 0; i < 3; i++) {
                        if (isStopRequestedRef.current) break; // Exit immediately if STOP was spoken
                        worker.postMessage({
                            type: 'writeArray',
                            value: bytesCode[connectedDevice.toUpperCase()][command],
                        })
                        await new Promise((r) => setTimeout(r, 1000))
                    }
                    // Stop it immediately after 3 seconds, do not wait for RDONE
                    worker.postMessage({
                        type: 'writeArray',
                        value: ['R'.charCodeAt(0), 'a'.charCodeAt(0)],
                    })
                    isActionRunningRef.current = false
                    return
                }

                if (isZingFramed && ZING_TIMED_STEPS[command]) {
                    worker.postMessage({
                        type: 'writeArray',
                        value: getZingSpeechBytes(
                            command,
                            connectedDevice,
                            deviceVersion,
                            bytesCode[connectedDevice.toUpperCase()]
                        ),
                    })
                    const walkEnd =
                        Date.now() + ZING_TIMED_STEPS[command] * ZING_STEP_MS
                    while (
                        Date.now() < walkEnd &&
                        !isStopRequestedRef.current
                    ) {
                        await new Promise((r) => setTimeout(r, 100))
                    }
                    // A spoken STOP/ATTENTION already sends attention itself
                    if (!isStopRequestedRef.current) {
                        worker.postMessage({
                            type: 'writeArray',
                            value: attentionBytes,
                        })
                    }
                    isActionRunningRef.current = false
                    return
                }

                // Normal discrete command flow
                worker.postMessage({
                    type: 'writeArray',
                    value: getZingSpeechBytes(
                        command,
                        connectedDevice,
                        deviceVersion,
                        bytesCode[connectedDevice.toUpperCase()]
                    ),
                })

                // Framed Zing sends no attention afterwards, so don't hold the lock waiting for a done reply.
                if (isZingFramed && command !== 'PUSHUP') {
                    isActionRunningRef.current = false
                    return
                }

                try {
                    let replyOK = await Promise.race([
                        checkDone(),
                        timeoutPromise(command === 'PUSHUP' ? 92500 : 12000),
                    ])
                    
                    if (needsFallDisable) {
                        // wait for the physical action to fully complete before re-enabling
                        await new Promise((r) => setTimeout(r, 2000))
                        zingFreeFallSendBytes({ worker, value: 1 })
                        await new Promise((r) => setTimeout(r, 100))
                    }

                } catch (e) {
                    if (needsFallDisable) {
                        zingFreeFallSendBytes({ worker, value: 1 })
                    }
                } finally {
                    isActionRunningRef.current = false
                    isPushUpRunningRef.current = false
                }
            })
            const commandLabel = commands
                .map(
                    (command) =>
                        matchedPhrases[command] ??
                        COMMAND_LABELS[command] ??
                        command.charAt(0) + command.slice(1).toLowerCase()
                )
                .join(', ')
            setFeedback(`${commandLabel} detected`)
        } else {
            setFeedback(
                "I didn't quite catch that, click on the mic to try again."
            )
        }
    }

    // Listening Toggle
    const handleListenToggle = () => {
        if (isListening) {
            speechStopRef.current = true
            wantsListeningRef.current = false
            recognitionRef.current.stop()
            setFeedback(
                `Tap the microphone and start talking to your ${connectedDeviceName}`
            )
        } else {
            speechStopRef.current = false
            wantsListeningRef.current = true
            recognitionRef.current.start()
        }
    }

    let history = useHistory()

    useEffect(() => {
        if (!isShowWardEditPopUp) return;

        const filteredData = wardsArray.filter(
            (item) => item.text.trim() !== '' && item.action.trim() !== ''
        )


        const customActionLabels = ActionsList.map((action) => action.label.toLowerCase())
        const customActionItems = filteredData.filter((item) => customActionLabels.includes(item.text.trim().toLowerCase()))
        
        if (customActionItems.length > 0) {
            const blockedTexts = customActionItems.map((item) => `"${item.text}"`).join(', ')
            setWarningPopup({
                isShow: true,
                message: `${blockedTexts} ${customActionItems.length > 1 ? 'are' : 'is'} custom action(s). You cannot overwrite them.`,
            })
            setWardsArray(prev => prev.map(item => customActionLabels.includes(item.text.trim().toLowerCase()) ? { ...item, text: '' } : item))
            return;
        }


        const textMap = {}
        const duplicateInfo = {}

        filteredData.forEach((item) => {
            const key = normalizeSpeech(item.text)
            if (textMap[key]) {
                if (!duplicateInfo[key]) {
                    duplicateInfo[key] = [textMap[key].action]
                }
                duplicateInfo[key].push(item.action)
            }
            textMap[key] = item
        })

        const duplicateKeys = Object.keys(duplicateInfo)

        if (duplicateKeys.length > 0) {
            const dupText = duplicateKeys[0]
            const dupLabel = filteredData.find(
                (item) => normalizeSpeech(item.text) === dupText
            ).text.trim()

            setDuplicateWarning({
                isShow: true,
                message: `The command "${dupLabel}" is assigned to multiple actions. Do you want to overwrite?`,
                onYes: () => {
                    const newWards = [];
                    const seen = {};
                    for (let i = wardsArray.length - 1; i >= 0; i--) {
                        const item = wardsArray[i];
                        const key = normalizeSpeech(item.text);
                        if (key === dupText) {
                            if (!seen[key]) {
                                seen[key] = true;
                                newWards.unshift(item);
                            }
                        } else {
                            newWards.unshift(item);
                        }
                    }
                    setWardsArray(newWards);
                    setDuplicateWarning({ isShow: false, message: '', onYes: () => {}, onNo: () => {} })
                },
                onNo: () => {
                    const newWards = [...wardsArray];
                    for (let i = newWards.length - 1; i >= 0; i--) {
                        if (normalizeSpeech(newWards[i].text) === dupText) {
                            newWards[i] = { ...newWards[i], text: '' };
                            break;
                        }
                    }
                    setWardsArray(newWards);
                    setDuplicateWarning({ isShow: false, message: '', onYes: () => {}, onNo: () => {} })
                },
            })
        }
    }, [wardsArray, isShowWardEditPopUp]);

    //handel close the actions map array editing poup
    const handelCloseWardEditPopup = () => {
        const filteredData = wardsArray.filter(
            (item) => item.text.trim() !== '' && item.action.trim() !== ''
        )
        // Saving is blocked until every command maps to a single action.
        const conflict = findSpeechConflict(
            filteredData,
            playModeStorage?.speech?.language || 'English'
        )
        if (conflict) {
            setWarningPopup({
                isShow: true,
                message: describeSpeechConflict(conflict),
            })
            return
        }

        const textMap = {}
        filteredData.forEach((item) => {
            textMap[normalizeSpeech(item.text)] = item
        })
        const uniqueLastObjects = Object.values(textMap)

        stopListening()
        setIsMicActive(-1)
        if (resumeListeningRef.current) {
            setTimeout(() => startListening(), 300)
        }

        isOpenEditPopUpRf.current = false
        setActionsMap(uniqueLastObjects)
        setIsShowWardEditPopUp(false)
    }

    //handel open the actions map array editing poup
    const handelOpenEditingPopUp = () => {
        resumeListeningRef.current = wantsListeningRef.current
        stopListening()
        isOpenEditPopUpRf.current = true
        let selectedLanguage = playModeStorage.speech.language
        setWardsArray([
            ...(playModeStorage.speech.actionsMap?.[selectedLanguage] ?? []),
        ])
        setIsShowWardEditPopUp(true)
    }

    const handelOpenLanguagePopup = () => {
        resumeListeningRef.current = wantsListeningRef.current
        stopListening()
        setTempLanguage(playModeStorage.speech.language)
        setIsShowLanguagePopUp(true)
    }
    const languageActionHandel = () => {
        if (tempLanguage.trim()) {
            setLanguageSelect(tempLanguage.trim())
        }
        if (resumeListeningRef.current) startListening()
        setIsShowLanguagePopUp(false)
    }

    function stopListening() {
        speechStopRef.current = true
        wantsListeningRef.current = false
        recognitionRef.current.stop()
    }
    function startListening() {
        speechStopRef.current = false
        wantsListeningRef.current = true
        try {
            recognitionRef.current.start()
        } catch (e) {
            // Already running (e.g. the auto-restart beat this call): that is the state we want.
            if (e?.name !== 'InvalidStateError') throw e
        }
    }

    //recived the data for zing v2
    useEffect(() => {
        const messageHandler = (e) => {
            if (e.data.type === 'read') {
                let combinedResult = e.data.value
                if (combinedResult.includes('RDONE')) {
                    sessionStorage.setItem('sendDataAsPacket', 'false')
                }
            }
        }
        worker.addEventListener('message', messageHandler)

        // return worker.removeEventListener('message', messageHandler)
    }, [])

    const handelGoBck = () => {
        if (isPushUpRunningRef.current) {
            setShowPushUpToast(true)
            return
        }
        stopListening()
        sessionStorage.setItem('slideDirection', true)
        history.push('/introduction')
        worker.postMessage({
            type: 'writeArray',
            value: attentionBytes,
        })
    }

    return (
        <div className="Speech-Main">
            {/* --------- language select popUp */}
            <Toast
                show={showPushUpToast}
                message="Please wait for the action to complete!"
                onClose={() => setShowPushUpToast(false)}
            />
            <DialogModal
                show={isShowLanguagePopUp}
                text={
                    <div>
                        <p>Select Your Prefer language</p>
                        <div>
                            <select
                                style={{
                                    width: '200px',
                                    height: '45px',
                                    padding: '5px',
                                    borderRadius: '10px',
                                }}
                                value={tempLanguage}
                                onChange={(e) =>
                                    setTempLanguage(e.target.value)
                                }
                            >
                                {speechLanguageMenu.map((ele) => {
                                    return (
                                        <option key={ele} value={ele}>
                                            {ele}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() => setIsShowLanguagePopUp(false)}
                optionsToSelect={[
                    {
                        text: 'CONTINUE',
                        do: () => {
                            languageActionHandel()
                        },
                    },
                ]}
            />
            <DialogModal
                // width={500}
                styles={{ maxWidth: '60vw' }}
                show={isShowWardEditPopUp}
                text={
                    <CustomWards
                        wardsArray={wardsArray}
                        setWardsArray={setWardsArray}
                        speechCommends={speechCommends}
                        setSpeechCommends={setSpeechCommends}
                        isMicActive={isMicActive}
                        setIsMicActive={setIsMicActive}
                        duplicateWarning={duplicateWarning}
                        warningPopup={warningPopup}
                        setWarningPopup={setWarningPopup}
                        stopListening={stopListening}
                        startListening={startListening}
                        languageName={playModeStorage?.speech?.language || 'English'}
                    />
                }
                showCloseBtn={true}
                handleDialogModalClose={handelCloseWardEditPopup}
            />

            <MainHeader
                title={languageWords[languageName]?.Speech || 'Speech'}
                helper={<SpchSlider />}
                showBluetoothBtn={true}
                goBack={handelGoBck}
                btns={['AI', 'Custom']}
                isShowAiSwipeBtn={isZing3Only}
                swipeActive={swipeActive}
                setSwipeActive={setSwipeActive}
                isShowEdit={isZing3}
                handelOpenEditingPopUp={handelOpenEditingPopUp}
                isShowLanguageIcon={isZing3}
                handelOpenLanguagePopup={handelOpenLanguagePopup}
            />

                <div className="Ace_Speech">
                    <div>
                        {connectedDevice === 'Ace' && (
                            <img
                                className="Ace_img"
                                src={
                                    getConnectedDeviceImage(
                                        connectedDevice,
                                        deviceVersion
                                    ) || renderImage('PC')
                                }
                            ></img>
                        )}
                        {connectedDevice === 'Humanoid' && (
                            isZing3 ? (
                                <model-viewer
                                    className="Ace_img"
                                    src="https://peeceev1.s3.ap-south-1.amazonaws.com/listen1.glb"
                                    camera-controls
                                    autoplay
                                    animation-name="Key|peecee_headtilt_listen|BaseLayer"
                                    style={{ height: '40vh' }}
                                ></model-viewer>
                            ) : (
                                <img
                                    className="Ace_img"
                                    src={
                                        getConnectedDeviceImage(
                                            connectedDevice,
                                            deviceVersion
                                        ) || renderImage('Zing')
                                    }
                                ></img>
                            )
                        )}
                        {connectedDevice === 'Hexapod' && (
                            <img
                                className="Hexa_img"
                                src={
                                    getConnectedDeviceImage(
                                        connectedDevice,
                                        deviceVersion
                                    ) ||
                                    (deviceVersion?.startsWith('2.2')
                                        ? renderImage('crawleV22')
                                        : renderImage('Hexapod'))
                                }
                            ></img>
                        )}
                    </div>
                    <div>
                        {!isListening ? (
                            <img
                                className="Mic_imgIA"
                                src={renderImage('SpeechIA_Svg')}
                                // onClick={handleMic}
                                onClick={handleListenToggle}
                            ></img>
                        ) : (
                            <img
                                className="Mic_img"
                                src={renderImage('SpeechAc_Svg')}
                                // onClick={handleMic}
                                onClick={handleListenToggle}
                            ></img>
                        )}
                    </div>
                </div>
                <div className="SoundWave">
                    {isListening && (
                        <img
                            className="Sound_Wave"
                            src={renderImage('Soundwaves_Svg')}
                        ></img>
                    )}
                </div>
            {isZing3 ? (
                <div className="zing3_speech_feedback">
                    <h3 className="text-center " style={feedbackStyle}>
                        {feedback}
                    </h3>
                </div>
            ) : (
                <div>
                    <h3 className="text-center " style={feedbackStyle}>
                        {feedback}
                    </h3>
                </div>
            )}
        </div>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        setLanguageSelect: (data) => {
            dispatch({ type: 'SET_LANGUAGE', payload: data })
        },
        setActionsMap: (data) => {
            dispatch({ type: 'SET_ACTIONS_MAP', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DeviceSpeech)
